import { FirmwareState } from '../types'
import Firmware from '../../models/firmware'
import Vue from 'vue'
import { GetterTree, MutationTree, ActionTree } from 'vuex'
import ApiResponse from 'models/apiResponse'

//Get an Firmware from a Vue component by calling this.$store.state.firmware.list;

const state: FirmwareState = {
    list: [],
}

const getters: GetterTree<FirmwareState, any> = {
    getFirmwareList: state => () => {
        return state.list;
    }
}

const mutations: MutationTree<FirmwareState> = {
    setFirmwareList(state, data) {
        //reset list first.
        state.list = [];
        data.forEach((firmware: Firmware, index) => {
            Vue.set(state.list, index, firmware);
        });
    }
}

const actions: ActionTree<FirmwareState, any> = {
    async fetchFirmwares({ commit, state }) {
        const url = Vue.IdentityConfig.legacyApiUri + "/remote/firmware/list";
        const options: RequestInit = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            cache: "no-cache"
        };
        await fetch(url, options)
            .then(response => response.json() as Promise<ApiResponse<Firmware[]>>)
            .then(data => {
                if (data.result && data.result.length > 0) {
                    const firmwares = [];
                    data.result.forEach(f => {
                        firmwares.push(new Firmware(f));
                    })
                    commit('setFirmwareList', firmwares);
                }
                if (data.errors) {
                    data.errors.forEach(e => Vue.Logger.LogError(e.message));
                }
            });
    }
}

export default {
    state,
    getters,
    mutations,
    actions
}